const config = {
    slidingClass: 'is-sliding',
    boilerplateClass: 'sliding-boilerplate'
};

export default class SlidingElement {
    constructor(element, window) {
        this.$window = $(window);
        this.$element = $(element);
        this.$boilerplate = $(`<div class="${config.boilerplateClass}"/>`)
            .height(this.$element.outerHeight(true))
            .insertAfter(this.$element);
    }

    toggle() {
        if (this.$element.length === 0) {
            return false;
        }

        this.$element.toggleClass(
            config.slidingClass,
            $(window).scrollTop() + $(window).height() < this.$boilerplate.offset().top + this.$boilerplate.height()
        );
    }

    setListeners() {
        this.$window
            .on('orientationchange', this.toggle.bind(this))
            .on('scroll', this.toggle.bind(this))
            .on('resize', this.toggle.bind(this));
    }

    init() {
        this.toggle.bind(this)();
        this.setListeners();
    }
}